<template>
  <base-modal :loaded="loaded" :modal-title="dashboardId == null ? 'Create Dashboard' : 'Edit Dashboard'" @save="save()" @close="close()">
    <h2>Settings</h2>
    <FormulateForm>
      <FormulateInput type="text" v-model="dashboardModel.name" label="Title" @input="dirtyStatus.name = true" />
      <FormulateInput type="select" v-model="dashboardModel.date_field" label="Date Field" :options="dateFields" @input="dirtyStatus.date_field = true" />
    </FormulateForm>
    <h2>Filter Rule</h2>
    <boolean-expression-widget :expression="dashboardModel.filter_rule" @updateExpression="updateFilterRule"></boolean-expression-widget>
    <h2>Pivots</h2>
    <FormulateForm>
      <table class="table table-noborder">
        <thead>
          <tr><th>Field</th><th></th></tr>
        </thead>
        <tbody>
          <tr v-for="pivot, ix in dashboardModel.pivots">
            <th>{{ pivot.name }}</th>
            <td><FormulateInput type="button" label="Remove" @click="removePivot(ix)" /></td>
          </tr>
          <tr>
            <td>
              <FormulateInput
                type="select"
                name="field"
                v-model="pivotToAdd"
                :options="availablePivots" />
            </td>
            <td>
              <FormulateInput class="add" type="button" label="Add" @click="addPivot" />
            </td>
          </tr>
        </tbody>
      </table>
    </FormulateForm>
    <h2 v-if="dashboardModel.id">Advanced</h2>
    <div v-if="dashboardModel.id" class="advanced">
      <button class="btn btn-primary" @click="cloneDashboard"><i class="fa fa-clone"></i> Clone Dashboard</button>
      <button class="btn btn-default" @click="removeDashboard"><i class="fa fa-trash"></i> Remove Dashboard</button>
    </div>
  </base-modal>
</template>

<script>
 import Vue from 'vue';
 import DateRangePicker from 'components/elements/DateRangePicker';
 import BooleanExpressionWidget from 'components/elements/BooleanExpressionWidget';
 import BaseModal from 'components/modals/BaseModal';

 // Load the full build.
 var _ = require('lodash');

 export default {
     components: {
         BooleanExpressionWidget,
         DateRangePicker,
         BaseModal
     },
     props: {
         dashboardId: {
             type: String,
             default: null
         }
     },
     data () {
         return {
             loaded: false,
             saved: true,
             types: [],
             dashboardModel: {
                 id: null,
                 name: '',
                 rules: null,
                 pivots: [],
                 date_field: null
             },
             dirtyStatus: {
                 name: false,
                 rules: false,
                 pivots: false,
                 date_field: false,
                 filter_rule: false
             },
             availableFields: [],
             dateFields: [],
             pivotToAdd: null
         };
     },
     computed: {
         pivotsUsed() {
             return new Set(_.map(this.dashboardModel.pivots, (p) => p.id ));
         },
         availablePivots() {
             var self = this;
             return this.availableFields
                        .filter((item, index) => !self.pivotsUsed.has(item.id))
                        .map(x => {
                            return {'id': x.id, 'value': x, 'label': x.name};
                        });
         }
     },
     created () {
         this.initDashboardModel(this.dashboardId);
     },
     methods: {
         save() {
             this.saveDashboard();
         },
         close() {
             this.$emit('close');
         },
         updateFilterRule(expression) {
             this.$set(this.dashboardModel, 'filter_rule', expression);
             this.dirtyStatus.filter_rule = true;
         },
         async initDashboardModel (id) {
             var self = this;
             if (id) {
                 let response = await API.dashboards.read(id);
	         self.dashboardModel = response.data;
             }
             await self.fetchDateFieldOptions();
             await self.fetchPivotOptions();
             self.loaded = true;
         },
         addPivot() {
             this.dashboardModel.pivots.push(this.pivotToAdd);
             this.dirtyStatus.pivots = true;
             this.pivotToAdd = null;
         },
         removePivot(ix) {
             this.dashboardModel.pivots.splice(ix, 1);
             this.dirtyStatus.pivots = true;
         },
         updatedDates (end_date, days) {
             // ToDo: Backend ERROR
             // ..... days:["This field may not be null."]
             if (end_date && days) {
                 this.dashboardModel.end_date = end_date;
                 this.dashboardModel.days = days;
             }
         },
         async fetchPivotOptions() {
             let response = await API.fields.getPivots({'indexed': 'true'});
             this.availableFields = response.data;
         },
         
         async fetchDateFieldOptions() {
             var self = this;
             let dateFields = await API.dateFields.getList();
             self.dateFields = [{id: 'default', value: 'default', label: 'default'}]
                               .concat(dateFields.data.map( (x) => { return { id: x.id, value: x.id, label: x.name } }));
             self.dashboardModel.date_field = self.dashboardModel.date_field || 'default';
         },
         saveDashboard: _.debounce(function () {
             var self = this;
             var req = {};
             self.saved = false;
             
             if (this.dashboardModel.id) {
                 req.id = this.dashboardModel.id;
             }

             _.forOwn(this.dirtyStatus, function (value, key) {
                 if (value) {
                     if (key == 'pivots') {
                         req.pivots =  self.dashboardModel.pivots;
                     }
                     else if (key == 'date_field') {
                         req.date_field = self.dashboardModel.date_field == 'default' ? null : self.dashboardModel.date_field;
                     }
                     else {
                         req[key] = _.cloneDeep(self.dashboardModel[key]);
                     }
                 }
             });
             
             API.dashboards.save(req)
                .then((response) => response.data)
                .then(function (data) {
                    // redirecting or refreshing
                    var redirecting = (req.id === undefined);
                    // closing modal
                    self.$emit('save', data);
	            self.$emit('close');
                    self.saved = true;
                });
         }, 500),
         cloneDashboard() {
             this.$emit('clone');
         },
         removeDashboard () {
             var r = confirm("This action will be permanent and it can't be recovered. Are you sure you want to continue?");
             if (r === true && this.dashboardId) {
	         var self = this;
	         API.dashboards.delete(this.dashboardId)
	            .then(function () {
	                self.$router.push({name: 'panel-home'});
	                BUS.$emit('refreshDashboardsList');
	            });
             }
         }
     }
 }
</script>




// WEBPACK FOOTER //
// DashboardModal.vue?7ec07b76